<template>
  <div>
    <!-- <div class="container">
      <dataPannel></dataPannel>
    </div>

    <div class="container">
      <e-search
        :data="listQuery"
        :field-list="fieldList"
        :list-type-info="listTypeInfo"
        :width="{ labelWidth: 90, itemWidth: 220 }"
        @handleFilter="handleQuery"
        @handleReset="handleReset"
      ></e-search>
    </div> -->

    <!-- 操作按钮 -->
    <div class="container">
      <div class="handle-wrapper">
        <eui-btn type="secondary" @click="goDetail('', 'add')"
          >绿色低碳数据收集</eui-btn
        >
      </div>
      <el-tabs v-model="activeIndex" type="card" @tab-click="handleTab">
        <el-tab-pane
          v-for="item in tabOption"
          :key="item.value"
          :label="item.label"
          :name="item.value"
        >
          <eTableList
            :table-data="tableData"
            :table-label="item.tableLabel"
            :index-show="true"
          >
            <template #handle="{ scope }">
              <eui-btn
                type="link"
                font-size="12px"
                @click="goDetail(scope.row, 'detail')"
                >查看详情</eui-btn
              >
              <eui-btn
                type="link"
                font-size="12px"
                @click="goDetail(scope.row, 'edit')"
                >编辑</eui-btn
              >
              <eui-btn
                type="link"
                font-size="12px"
                @click="deleteItem(scope.row)"
                >删除</eui-btn
              >
            </template>
          </eTableList>
        </el-tab-pane>
      </el-tabs>

      <div class="pagination">
        <el-pagination
          :pager-count="5"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="listQuery.pageNum"
          :total="total"
          :page-size.sync="listQuery.pageSize"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
    <itemEdit
      v-if="itemEditVisible"
      :item-data="itemData"
      :visible.sync="itemEditVisible"
      :title="itemTitle"
      @submitPopupData="submitPopupData"
    />
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/carbonfoot';
// import eSearch from '@/modules/projectA/components/common/e-search';
import eTableList from '@/modules/projectA/components/common/e-table-list';
import dataPannel from './components/dataPannel.vue';
import itemEdit from './itemEdit.vue';

import {
  tableLabel,
  tableLabel1,
  tableLabel2,
  tableLabel3,
  tableLabel4,
  tableLabel5,
  fieldList,
  listTypeInfo,
} from './componentsData.js';

export default {
  components: {
    dataPannel,
    eTableList,
    itemEdit,
  },
  data() {
    return {
      tableLabel,
      fieldList,
      listTypeInfo,
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        dataType: '2',
      },
      cloneListQuery: {},
      total: 0,
      tableData: [],
      tabOption: [
        {
          id: 'certificate',
          label: '碳足迹证书',
          value: '2',
          key: 'carbonCertList',
          ref: 'carbonfootprintCertificate',
          tableLabel,
          url: 'greenCarbonCert',
        },
        {
          id: 'report',
          label: '碳足迹报告',
          value: '4',
          key: 'carbonReportList',
          ref: 'carbonfootprintReport',
          tableLabel: tableLabel1,
          url: 'greenCarbonReport',
        },
        {
          id: 'factory',
          label: '绿色工厂评价',
          value: '8',
          key: 'factory',
          ref: 'greeFactoryEvalution',
          tableLabel: tableLabel2,
          url: 'greenFactory',
        },
        {
          id: 'supplyChain',
          label: '绿色供应链评价',
          value: '16',
          key: 'supplyChain',
          ref: 'supplyChain',
          tableLabel: tableLabel3,
          url: 'greenSupplyChain',
        },
        {
          id: 'productList',
          label: '中国绿色产品认证',
          value: '32',
          key: 'productList',
          ref: 'productList',
          tableLabel: tableLabel4,
          url: 'greenProduct',
        },
        {
          id: 'other',
          label: '其他',
          value: '64',
          key: 'other',
          ref: 'other',
          tableLabel: tableLabel5,
          url: 'greenOther',
        },
      ],
      itemEditVisible: false,
      itemTitle: '',
      activeIndex: '2',
      modelUrl: 'greenCarbonCert',
    };
  },
  computed: {
    mall_userInfo() {
      return this.$store.state.USERINFO;
    },
  },
  watch: {
    mall_userInfo: {
      immediate: true,
      handler(newVal) {
        this.userInfo = newVal;
        if (newVal.companyId) {
          this.companyId = newVal.companyId;
        }
      },
    },
  },
  created() {
    this.cloneListQuery = this.$options.data().listQuery;
    this.getList(this.listQuery);
  },
  methods: {
    handleTab(row) {
      const activeOption = this.tabOption.find(
        (item) => item.value === this.activeIndex
      );

      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = 10;
      this.listQuery.dataType = row.name;
      this.modelUrl = activeOption.url;
      this.getList(this.listQuery);
    },
    async submitPopupData(data) {
      console.log(data);
      // this.$message.success('提交成功');
      const update = await Api.update(
        {
          id: data.id,
          ...data.data,
        },
        this.modelUrl
      );
      if (update.code === '200') {
        this.$message.success('提交成功');
        this.itemEditVisible = false;
        this.getList(this.listQuery);
      }
    },
    async goDetail(row, type) {
      console.log(row, type);
      if (type === 'add') {
        this.$router.push({
          path: '/CarbonfootprintManage/CarbonfootprintDetail',
          query: {
            type,
          },
        });
        return;
      }
      const activeIndex = this.tabOption.find(
        (item) => item.value === this.activeIndex
      );
      this.itemTitle = type === 'edit' ? '编辑' : '查看';
      const res = await Api.detail(
        {
          id: row.id,
        },
        this.modelUrl
      );
      if (res.code === '200') {
        this.itemData = {
          ...res.data,
          type,
          ref: activeIndex.ref,
          key: activeIndex.key,
        };
      }
      // this.itemData = {
      //   ...row,
      //   type,
      //   ref: activeIndex.ref,
      //   key: activeIndex.key,
      // };
      this.itemEditVisible = true;
    },
    async deleteItem(row) {
      this.$confirm('您确认要删除吗？不可恢复！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const res = await Api.delete(
          {
            id: row.id,
          },
          this.modelUrl
        );
        if (res.code === '200') {
          this.$message.success('删除成功');
          this.getList(this.listQuery);
        }
      });
    },

    // 获取列表数据
    async getList(params) {
      this.tableLoading = true;
      await Api.queryPage(params, this.modelUrl).then((res) => {
        this.tableLoading = false;
        if (res.code === '200') {
          const { data } = res;
          this.tableData = [...data?.records];
          this.total = data?.total;
        }
      });
    },
    // 更改页码
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getList(this.listQuery);
    },

    // 更改条数
    handleSizeChange(val) {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = val;
      this.getList(this.listQuery);
    },

    // 重置
    handleReset() {
      this.listQuery = { ...this.cloneListQuery };
      this.getList(this.listQuery);
    },

    // 搜索
    handleQuery(val) {
      console.log(val);
      if (val.createTime?.length) {
        val.startTime = val.createTime[0];
        val.endTime = val.createTime[1];
      } else {
        val.startTime = '';
        val.endTime = '';
        val.createTime = [];
      }
      this.listQuery = { ...val, pageNum: 1 };
      this.getList(this.listQuery);
    },
  },
};
</script>

<style lang="scss" scoped></style>
